export default "__VITE_ASSET__DbPVRclL__"